import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';

interface IProps {
  ratio: number;
}

const Bar = styled.div`
  display: inline-block;
  width: 100%;
  height: 16px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const BarFill = styled.div`
  background-color: ${colors.sky__55cdff};
  height: 100%;
`;

export class CvCoverageBar extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <Bar>
        <BarFill style={{ width: `${this.props.ratio}%` }} />
      </Bar>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/CvCoverageBar.tsx